import { QueryModelCore } from "@/core/model.core";

export default class Cms {
  /**
   * 获取专题页信息
   * @param {Number} id 专题id
   */
  async subjectInfo(id) {
    const result = await new QueryModelCore('/api-cms/special/topic/app/get').get({ id });
    const { dataMap } = result;
    return dataMap;
  }

  /**
 * 获取目的地信息及商品(分页)
 * @param {number} id 城市id
 * @param {number} current
 * @param {number} size
 */
  async getDestinationPagingList(params) {
    const result = await new QueryModelCore('/api-cms/app/destinationAddress/detail').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 目的地(新版) --> 列表
  async getDestinationCity(params) {
    const result = await new QueryModelCore('/api-cms/app/destinationAddress/destinationList').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 搜索框查询目的地
  async getDestinationSearch(params) {
    const result = await new QueryModelCore('/api-cms/app/destinationAddress/queryByDestinationName').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取专题配置信息
   * @param {String} key
   */
  async getValueByKey(key) {
    const result = await new QueryModelCore('/api-prod/wx/getParamByKey').get({ key });
    const { dataMap } = result;
    return dataMap;
  }

}